(function (window, document) {
	// ---------------------------------------------------------------
	// ultra Swiper
	let ultraSwiper = null;

	function buildUltraCarousel() {
		const swiperTarget = '#ultra-swiper';

		ultraSwiper = new Swiper(swiperTarget, {
			slidesPerView: 1,
			loop: true,
			speed: 700,
			lazy: true,
			navigation: {
				nextEl: swiperTarget + ' .swiper-button-next',
				prevEl: swiperTarget + ' .swiper-button-prev',
			},
			pagination: {
				el: swiperTarget + ' .swiper-pagination',
				clickable: true
			}
		});
	}

	window.addEventListener('load', buildUltraCarousel);

	// product Swiper
	let productSwiper = null;

	function buildProductCarousel() {
		const swiperTarget = '#product-carousel';

		productSwiper = new Swiper(swiperTarget, {
			slidesPerView: 'auto',
			spaceBetween: 24,
			navigation: {
				nextEl: '.sec-card--swiper .swiper-button-next',
				prevEl: '.sec-card--swiper .swiper-button-prev',
			}
		});
	}

	window.addEventListener('load', buildProductCarousel);

	// ---------------------------------------------------------------
	var videoBox = $('.video-box');
	var youTubeSetting = '';

	var videoIframe = null;

	var buildVideoBox = function () {
		if (videoBox.length === 0) return false;

		var videoPopup = $('#video-popup');
		var videoPopupPlayer = videoPopup.find('.video-player');

		videoBox.each(function () {
			var currentItem = $(this);
			var youTubeUrl = currentItem.data('video');
			var youTubeId = getYoutubeId(youTubeUrl);

			// Get Title
			// getYouTubeTitle(youTubeId, function(title) {
			// 	currentItem.parent().find('.video-box__title').text(title)
			// });

			// 寫入Properties
			this.videoId = youTubeId;

			var videoImg = currentItem.find('.video-box__preview');
			var videoPlayPopup = currentItem.find('[data-video-popup]');

			var videoIframeSrc = 'https://www.youtube.com/embed/' + youTubeId + youTubeSetting;
			var youTubeIframeString =
				'<iframe width="1080" height="608" class="video-player" src="' +
				videoIframeSrc +
				'" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>';

			// Video Cover
			var videoCoverData = currentItem.data('cover');
			var videoCover =
				videoCoverData !== undefined ? videoCoverData : 'https://img.youtube.com/vi/' + youTubeId + '/0.jpg';
			if (videoImg.hasClass('lazy')) {
				// 有LazyLoad
				videoImg.attr('data-background', videoCover);
				if (videoImg.parents('.swiper-slide') !== undefined) {
					// 有Swiper的情況
					videoImg.addClass('swiper-lazy');
				} else {
					// 一般情況
					if (document.body.setLazy !== undefined) document.body.setLazy();
				}
			} else {
				// 沒有Lazy
				videoImg.css({
					'background-image': 'url(' + videoCover + ')'
				});
			}

			// Click and load iframe
			videoPlayPopup.on('click', function () {
				videoPopupPlayer.append(youTubeIframeString);
			});
		});

		$('[data-modal-close]').on('click', function() {
			videoPopup.find('iframe').remove();
		});
		// ---------------------------------------------------------------
	};

	// Start
	window.addEventListener('load', buildVideoBox);

	// 讀取網址
	// get-youtube-info.js: https://gist.github.com/ramonvictor/5629626
	function getYoutubeId(url){
		var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
		var match = url.match(regExp);
		if(match&&match[7].length==11){ 
			return match[7];
		}
		return false;
	}
	// ---------------------------------------------------------------

	// ---------------------------------------------------------------
	// 隨機上色
	const colorStr = $('#leading').attr('data-bgcolors');
	const colorStrDefault = $('#leading').attr('data-default-bgcolors');

	let colors = colorStrDefault.replaceAll(' ', '').split(',');

	if (colorStr && colorStr.length) {
		colors = colorStr.replaceAll(' ', '').split(',');
	}

	const getRandomKey = getRandomInt(colors.length);
	$('.sec-leading').css('background-color', colors[getRandomKey]);

	function getRandomInt(max) {
		return Math.floor(Math.random() * max);
	}
	// ---------------------------------------------------------------

	// ---------------------------------------------------------------
	// 展開 swiper
	const offset = $(window).innerWidth() >= 960 ? 89 : 81;

	$(document).on('click', '.js-open-slide', function() {
		const $wrap = $(this).parents('.sec-ultra');

		if ($wrap.hasClass('is-open-slide')) {
			$wrap.removeClass('is-open-slide');
		} else {
			$wrap.addClass('is-open-slide');

			$('html, body').stop().animate({scrollTop: $wrap.offset().top - offset},550);
		}
	});

	// ---------------------------------------------------------------
})(window, document);

(function (window, document) {
	var rideId;
	var rideType;

	var vm = new Vue({
		data: {
			cardList: null,
			//- modal
			modalStatus: false,
			modalKey: null,
			modalData: null
		},
		//- template: `<div id="app"><button-counter></button-counter></div>`,
		methods: {
			handlePalette: function (palette) {
				const linear2 = palette.color[1] ? palette.color[1] : palette.color[0];

				return (
					'background: linear-gradient(39.81deg, ' + palette.color[0] + ' 14.39% , ' + linear2 + ' 83.71%);'
				);
			},

			handleCarSwitch: function (item, key) {
				item.selectedKey = key;
			},

			checkItemPostTime: function (obj) {
				var postStart = obj.postStart;
				var autoPauseAfter = obj.autoPauseAfter;
				var now = Math.floor(Date.now() / 1000);

				return now - postStart > 0 && now - autoPauseAfter < 0 ? true : false;
			}
		},
		watch: {
			"modalStatus": function(val) {
				//- console.log(val);
				//- var lazyLoadInstance = new LazyLoad();
			}
		},
		created: function () {
			var that = this;

			var jsonPath = $('body').attr('data-pagepath');

			$.ajax({
				url: '../../' + jsonPath + '/data.json',
				type: 'GET',
				dataType: 'json',
				success: function (Jdata) {
					Jdata.map(function (item) {
						item['selectedKey'] = 0;
					});

					that.cardList = Jdata;
					that.modalKey = 0;
					that.modalData = Jdata[0].popup;
				},
				error: function (error) {
					console.log(error);
				}
			});
		},
		mounted: function () {
		}
	});

	vm.$mount('#ride-app');

	$(document).on('click', '[data-modal-open]', function() {
		$('#ride-app .ride-modal__info').scrollTop(0);
		rideId = $(this).attr('data-ride-id');
		rideType = $(this).attr('data-ride-type');

		vm._data.cardList.map(function(item, index) {
			if (+item.id === +rideId) {
				vm.$data.modalData = item['popup'];
				vm.$data.modalKey = index;
				vm.$data.modalStatus = true;
			}
		});
	});

	// 示意關閉 modal
	$(document).on('click', '[data-modal-close]', function() {
		vm.$data.modalStatus = false;
	});
})(window, document);
(function (window, document) {
	var win = $(window);
	var ww = win.innerWidth();
	var wh = win.innerHeight();
	var window_width = win.width();
	var ws = win.scrollTop();

	var resizeWindow = function () {
		ww = win.innerWidth();
		wh = win.innerHeight();
	};

	$(window)
		.on('load', function () {
			resizeWindow();
			scrollJS();
		})
		.on('scroll', function () {
			resizeWindow();
			scrollJS();

			ws = win.scrollTop();
		})
		.on('resize', function () {
			resizeWindow();

			scrollJS();
		});

	// =================================================
	// Nav link anchor
	const offset = ww >= 960 ? 89 : 81;
	const $body = document.querySelector('html');
	const $navSec = document.querySelectorAll('.js-nav-anchor');

	const scrollTriggerAniThrottle = throttle(scrollTriggerAni, 50, 100); // 節流作用

	function scrollTriggerAni() {
		for (var i = 0; i < $navSec.length; i++) {
			const elPosTop = $navSec[i].offsetTop;
			const nextPosTop =
				i + 1 >= $navSec.length ? Math.floor($body.offsetHeight) : Math.ceil($navSec[i + 1].offsetTop);
			const secId = $navSec[i].getAttribute('id');

			if (ws >= elPosTop - offset && ws < nextPosTop - offset) {
				$('.sec-sertag [href="#' + secId + '"]').addClass('is-active');
			} else {
				$('.sec-sertag [href="#' + secId + '"]').removeClass('is-active');
			}
		}
	}

	window.addEventListener('load', scrollTriggerAni);
	window.addEventListener('scroll', scrollTriggerAniThrottle);

	// Nav link anchor
	function scrollJS() {
		// 頁面滾動時的動畫判斷
		var window_top_position = win.scrollTop();
		var kvH = $('.viewpage-hd .sec-serhd').height() + $('.viewpage-hd').offset().top;

		if (window_top_position >= kvH) {
			$('.viewpage-hd').addClass('scroll fixed');
		} else {
			$('.viewpage-hd').removeClass('scroll fixed');
		}
	}

	$(document).on('click', '.js-nav-link', function (e) {
		e.preventDefault();

		const $el = $('.viewpage-hd');
		const navHeight = $el.find('.serhd-ctr').height();
		const navTopHeight = $el.find('.sec-serhd').height();
		const navBottomHeight = $el.find('.sec-sertag').height();
		const thisId = $(this).attr('href');

		const scrollTopPos =
			$(this).index() == 0 ? Math.ceil($(thisId).offset().top) - 46 : Math.ceil($(thisId).offset().top) - offset;

		$('html, body').stop().animate(
			{
				scrollTop: scrollTopPos
			},
			550
		);
	});

	// =================================================

	// =================================================
	// https://www.cnblogs.com/coco1s/p/5499469.html
	// 簡單的節流函數
	function throttle(func, wait, mustRun) {
		let timeout;
		let startTime = new Date();

		return function () {
			const context = this;
			const args = arguments;
			const curTime = new Date();

			clearTimeout(timeout);
			// 如果达到了规定的触发时间间隔，触发 handler
			if (curTime - startTime >= mustRun) {
				func.apply(context, args);
				startTime = curTime;
				// 没达到触发间隔，重新设定定时器
			} else {
				timeout = setTimeout(func, wait);
			}
		};
	}
	// =================================================
})(window, document);
